(function () {
  "use strict";

  angular.module("sempraWebapp").factory("LanguagesEnum", languagesEnumFactory);

  /** @ngInject */
  function languagesEnumFactory() {
    return Object.freeze([
      {
        locale: "en",
        name: "English",
        englishName: "ENGLISH"
      },
      {
        locale: "sr",
        name: "Srpski",
        englishName: "SERBIAN"
      },
      {
        locale: "hr",
        name: "Hrvatski",
        englishName: "CROATIAN"
      },
      {
        locale: "fr",
        name: "Français",
        englishName: "FRENCH"
      },
      {
        locale: "cs",
        name: "Čeština",
        englishName: "CZECH"
      },
      {
        locale: "sl",
        name: "Slovenščina",
        englishName: "SLOVENIAN"
      },
      {
        locale: "uk",
        name: "Український",
        englishName: "UKRAINIAN"
      },
      {
        locale: "ru",
        name: "Pусский",
        englishName: "RUSSIAN"
      },
      {
        locale: "de",
        name: "Deutsche",
        englishName: "GERMAN"
      },
      {
        locale: "hu",
        name: "Magyar",
        englishName: "HUNGARIAN"
      },
      {
        locale: "ro",
        name: "Română",
        englishName: "ROMANIAN"
      },
      {
        locale: "nl",
        name: "Nederland",
        englishName: "DUTCH"
      },
      {
        locale: "sv",
        name: "Svenska",
        englishName: "SWEDISH"
      }
    ]);
  }
})();
